import React from 'react'
import Navbar from '../Navbar/Navbar'
import Footer from '../Home/Footer'
import CommercialsDetails from '../Commercials/CommercialsDetails'

const Commercialspage = () => {
    return (
        <div>
        <Navbar/>
        <CommercialsDetails/>

        <Footer/>

        </div>
    )
}

export default Commercialspage